import React from 'react';
import { FormGroup, FormControl, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';

import LoadingComponent from '../core/LoadingComponent/LoadingComponent';
import LinkComponent from '../core/LinkComponent/LinkComponent';
import { COPYRIGHTS_DATE } from '../core/MenuComponent/MenuConstants';
import './footer.scss';
import CONFIG from '../../config/config';

const RESOURCES = [
    // {
    //     title: 'Github',
    //     url: '#',
    // },
    {
        title: 'Marketing Guidelines',
        url: '/marketing',
    },
];

const OUR_BRANDS = [
    {
        title: 'Life Fitness',
        url: 'https://lifefitness.com/',
    },
    {
        title: 'Hammer Strength',
        url: 'https://lifefitness.com/hammer-strength/',
    },
    {
        title: 'Cybex',
        url: 'http://www.cybexintl.com/',
    },
    {
        title: 'Indoor Cycling Group',
        url: 'https://www.teamicg.com/',
    },
    {
        title: 'SCIFIT',
        url: 'http://www.scifit.com/',
    },
    // {
    //     title: 'Brunswick Billiards',
    //     url: 'https://www.brunswickbilliards.com/',
    // },
];

class FooterComponent extends React.Component {
    componentWillMount() {
        this.props.isTosUpdated();
    }

    render() {
        const { isLoading, isLandingOrEntryPage, tosTitle } = this.props;

        if (isLoading) {
            return <LoadingComponent fullScreen />;
        }

        return <div className={`Footer-component${isLandingOrEntryPage ? ' landing' : ''}`}>
            <div className="container">
                {/*Temporarily disable for now*/}
                <div className="signupFooter">
                    <form>
                        <FormGroup>
                            <FormControl
                                type="text"
                                placeholder="Get Halo Fitness for Developers API updates"
                            />
                        </FormGroup>
                        <Button>Sign Up</Button>
                    </form>
                </div>
                <div className="info-wrapper">
                    <div className="resources">
                        <h4>RESOURCES:</h4>
                        {RESOURCES.map((props, i) => <LinkComponent key={i} {...props} />)}
                    </div>
                    <div className="brands">
                        <h4>OUR BRANDS:</h4>
                        {OUR_BRANDS.map((props, i) => <LinkComponent key={i} {...props} isExternalLink />)}
                    </div>
                </div>
            </div>
            <hr />
            <div className="container bottom">
                <div>
                    <p>
                        ©{COPYRIGHTS_DATE.copyrights_date} Life Fitness.&nbsp;
                        <LinkComponent
                            url={CONFIG.termsAndConditionsURL}
                            title={tosTitle}
                            isExternalLink
                        />. All Rights Reserved.
                    </p>
                </div>
                <div>
                    <LinkComponent
                        className="about"
                        url="https://support.lifefitness.com/hc/en-us/sections/22050179832471-Facility-Connect"
                        title="About Facility Connect"
                        isExternalLink
                    />
                </div>
            </div>
        </div>;
    }
}

FooterComponent.propTypes = {
    isTosUpdated: PropTypes.func.isRequired,
    tosTitle: PropTypes.string.isRequired,
    isLoading: PropTypes.bool.isRequired,
    isLandingOrEntryPage: PropTypes.bool,
};

export default FooterComponent;



// WEBPACK FOOTER //
// ./src/components/footer/FooterComponent.js